export const SET_ACTIVE_NOTE_ID = 'PUBLICUI/SET_ACTIVE_NOTE_ID'
export const TOGGLE_EXPAND_NOTE = 'PUBLICUI/TOGGLE_EXPAND_NOTE'
export const EXPAND_NOTE = 'PUBLICUI/EXPAND_NOTE'
export const EXPAND_NOTES = 'PUBLICUI/EXPAND_NOTES'
